<template>
  <BaseModal name="soundkit-terms" :width="'100%'" :max-width="content ? 900 : 600" :height="'auto'" :adaptive="true" :scrollable="true" @before-open="onOpen">
    <BaseModalHeader>
       Sound Pack Terms
    </BaseModalHeader>
    <div class="tw-text-infinity-tertiary-text tw-mt-0.5">
      {{ licenseName }}
    </div>
    <div class="tw-mt-4 tw-border tw-border-infinity-border tw-border-solid tw-p-3 tw-rounded tw-overflow-auto tw-text-infinity-primary-text"
         :class="{'tw-text-center tw-italic tw-text-infinity-tertiary-text': !content}"
         v-html="content || 'This pricing has no terms.'"
         style="max-height: 60vh;" />
  </BaseModal>
</template>
<script>
import BaseModal from "../base/base-modal.vue";
import BaseModalHeader from "../base/base-modal-header";
import SoundKit from "../../models/soundkit";

export default {
  components: { BaseModalHeader, BaseModal },
  data() {
    return {
      pricingOption: null,
    }
  },
  computed: {
    licenseName() {
      return this.pricingOption?.pricingTemplateOption?.name
    },
    content() {
      return SoundKit.parseTerms(this.pricingOption)
    }
  },
  methods: {
    onOpen(event) {
      this.pricingOption = event.params.pricingOption
    }
  }
};
</script>
